export const FACE_POS = "FACE_POS"
export const TERMINAL = "TERMINAL"